// extracted by mini-css-extract-plugin
export default {"hero":"Index_hero__Qo3Mq","hero-img":"Index_hero-img__trrHZ","hero-inner":"Index_hero-inner__eZ3Ah","hero-text":"Index_hero-text__s6bHy","fadeInUp":"Index_fadeInUp__rxULp"};